import { VALID_PROTOCOLS } from '../constants/index';
export function parseValue(value, type, key) {
    switch (type) {
        case 'string':
            return value;
        case 'number': {
            const parsed = Number(value);
            if (value === '' || isNaN(parsed)) {
                throw new Error(`${key} must be a number, got "${value}"`);
            }
            return parsed;
        }
        case 'boolean': {
            if (value === 'true')
                return true;
            if (value === 'false')
                return false;
            throw new Error(`${key} must be "true" or "false", got "${value}"`);
        }
        case 'protocol': {
            if (!VALID_PROTOCOLS.includes(value)) {
                throw new Error(`${key} must be "http" or "https", got "${value}"`);
            }
            return value;
        }
    }
}
